import { isEmpty } from 'ramda'
import { useChangeSearch, useFilter, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FiltersBar from './filters/FiltersBar'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useRequeueFailedTasks } from './_requests/requeueFailedTasks'

const ControlBar = () => {
  const { t } = useTranslation()

  const hasFilter = !isEmpty(useFilter())
  const [isFiltering, setFiltering] = React.useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const changeSearch = useChangeSearch()
  const search = useSearch()

  const [requeueFailedTasks, { loading }] = useRequeueFailedTasks()

  const { t: tTriggerCalls } = useTranslation('triggerCalls')
  const options = [
    { label: t('views.list'), value: 'list', iconLeft: 'BsListTask' },
    { label: tTriggerCalls('cardsViewComingSoon'), disabled: true, value: 'cards', iconLeft: 'BsCardText' }
  ]

  return (
    <>
      <Separator weight={4} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <DropdownLink
            actionContent={<IconButton iconLeft="BsListTask" label={t('views.list')} transparent noWrap />}
            options={options}
          />
        </Col>

        <Col>
          {false && <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />}
        </Col>

        <Col flex={3} />

        <Col>
          <IconButton
            iconLeft="BsArrowClockwise"
            label={t('requeue_failed_tasks')}
            transparent
            noWrap
            onClick={requeueFailedTasks}
            loading={loading}
          />
        </Col>
      </Grid>
      <Separator weight={4} />

      <FiltersBar open={isFiltering} onClose={hideFilter} />
    </>
  )
}

export default ControlBar
